"use strict";

import { lookupTableConstants } from "../_constants";

export const lookupTableListRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_LIST_REQUEST,
          payload,
     };
};

export const lookupTableListComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_LIST_COMPLETE,
          payload,
     };
};

export const lookupTableAddRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_ADD_REQUEST,
          payload,
     };
};

export const lookupTableAddComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_ADD_COMPLETE,
          payload,
     };
};

export const lookupTableUpdateRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_UPDATE_REQUEST,
          payload,
     };
};

export const lookupTableUpdateComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_UPDATE_COMPLETE,
          payload,
     };
};

export const lookupTableDeleteRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_DELETE_REQUEST,
          payload,
     };
};

export const lookupTableDeleteComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_DELETE_COMPLETE,
          payload,
     };
};

export const lookupTableGetRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_GET_REQUEST,
          payload,
     };
};

export const lookupTableGetComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_GET_COMPLETE,
          payload,
     };
};

export const lookupTableTypesRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_TYPES_REQUEST,
          payload,
     };
};

export const lookupTableTypesComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_TYPES_COMPLETE,
          payload,
     };
};

export const lookupTableLabelsRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_LABELS_REQUEST,
          payload,
     };
};

export const lookupTableLabelsComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_LABELS_COMPLETE,
          payload,
     };
};

export const lookupTableActiveInactiveRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_ACTIVE_INACTIVE_REQUEST,
          payload,
     };
};

export const lookupTableActiveInactiveComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_ACTIVE_INACTIVE_COMPLETE,
          payload,
     };
};

export const lookupTableValueListRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_VALUE_LIST_REQUEST,
          payload,
     };
};

export const lookupTableValueListComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_VALUE_LIST_COMPLETE,
          payload,
     };
};

export const lookupTableValueAddRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_VALUE_ADD_REQUEST,
          payload,
     };
};

export const lookupTableValueAddComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_VALUE_ADD_COMPLETE,
          payload,
     };
};

export const lookupTableValueUpdateRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_VALUE_UPDATE_REQUEST,
          payload,
     };
};

export const lookupTableValueUpdateComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_VALUE_UPDATE_COMPLETE,
          payload,
     };
};

export const lookupTableValueDeleteRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_VALUE_DELETE_REQUEST,
          payload,
     };
};

export const lookupTableValueDeleteComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_VALUE_DELETE_COMPLETE,
          payload,
     };
};

export const lookupTableValueGetRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_VALUE_GET_REQUEST,
          payload,
     };
};

export const lookupTableValueGetComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_VALUE_GET_COMPLETE,
          payload,
     };
};

export const lookupTableCSVFileUploadRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_CSV_FILE_UPLOAD_REQUEST,
          payload,
     };
};

export const lookupTableCSVFileUploadComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_CSV_FILE_UPLOAD_COMPLETE,
          payload,
     };
};

export const lookupTableCSVFileUploadClear = () => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_CSV_FILE_UPLOAD_CLEAR,
     };
};

export const lookupTableSingleCSVFileUploadRequest = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_SINGLE_CSV_FILE_UPLOAD_REQUEST,
          payload,
     };
};

export const lookupTableSingleCSVFileUploadComplete = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_SINGLE_CSV_FILE_UPLOAD_COMPLETE,
          payload,
     };
};

export const lookupTableSingleCSVFileUploadClear = () => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_SINGLE_CSV_FILE_UPLOAD_CLEAR,
     };
};

export const lookupTableSaveSearchValues = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_SAVE_SEARCH_VALUES, 
          payload,
     }
}

export const lookupTableChangeStatus = (payload) => {
     return {
          type: lookupTableConstants.LOOKUP_TABLE_CHANGE_STATUS, 
          payload,
     }
}


